import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { DATES } from 'app/_constants/dates.constant';

@Component({
    selector: 'pkp-phase-label',
    template: `
        <span
            class="label"
            [ngClass]="{
                'label-live':
                    (phase === 'OPEN' || phase === 'IN_PROGRESS') && !suspended,
                'label-warning':
                    (phase === 'OPEN' && suspended) ||
                    phase === 'CLOSED' ||
                    phase === 'WITHDRAWN' ||
                    phase === 'DELETED',
                'label-medium':
                    phase === 'CANCELLED' ||
                    phase === 'FINISHED' ||
                    phase === 'PUBLISHED',
                'label-info':
                    phase === 'CANCELLED' ||
                    phase === 'FINISHED' ||
                    phase === 'PUBLISHED' ||
                    phase === 'NEW',
                'label-lg': largeLabel,
                'label-extra-wide': phase === 'IN_PROGRESS'
            }"
        >
            <span [hidden]="!(phase === 'OPEN' && !suspended)"> OPEN </span>
            <span [hidden]="!(phase === 'OPEN' && suspended)"> SUSPENDED </span>
            <span [hidden]="!(isAuction && phase === 'CLOSED')">
                Waiting for next round
            </span>
            <span [hidden]="!(!isAuction && phase === 'CLOSED')"> CLOSED </span>
            <span [hidden]="!(phase === 'CANCELLED')"> CANCELLED </span>
            <span [hidden]="!(phase === 'FINISHED')"> FINISHED </span>
            <span [hidden]="!(phase === 'NEW')"> NEW </span>
            <span [hidden]="!(phase === 'WITHDRAWN')"> WITHDRAWN </span>
            <span [hidden]="!(phase === 'DELETED')"> DELETED </span>
            <span [hidden]="!(phase === 'PUBLISHED' && isAuction)">
                Start of auction: {{ auctionStart | date: dateFormat }}
            </span>
            <span [hidden]="!(phase === 'PUBLISHED' && !isAuction)">
                Start of offer window: {{ auctionStart | date: dateFormat }}
            </span>
            <span [hidden]="!(phase === 'IN_PROGRESS')"> IN PROGRESS </span>
        </span>
    `
})
export class PhaseLabelComponent implements OnInit {
    private _phase: string;
    private _suspended: boolean;
    private _isAuction: boolean;
    private _auctionStart: Date | string;

    @Input() public largeLabel: boolean;

    public readonly dateFormat: string = new DATES().DATETIME_DEFAULT;

    ngOnInit() {
        if (this.largeLabel) {
            // force small for some
            this.largeLabel = !(
                this.phase === 'CLOSED' ||
                (this.phase === 'OPEN' && this.suspended) ||
                this.phase === 'CANCELLED' ||
                this.phase === 'PUBLISHED' ||
                this.phase === 'WITHDRAWN' ||
                this.phase === 'DELETED'
            );
        }
    }

    get phase(): string {
        return this._phase;
    }

    @Input() set phase(value: string) {
        this._phase = value;
    }

    get suspended(): boolean {
        return this._suspended;
    }

    @Input() set suspended(value: boolean) {
        this._suspended = value;
    }

    get isAuction(): boolean {
        return this._isAuction;
    }

    @Input('is-auction') set isAuction(value: boolean) {
        this._isAuction = value;
    }

    get auctionStart(): Date | string {
        return this._auctionStart;
    }

    @Input('auction-start') set auctionStart(value: Date | string) {
        this._auctionStart = value;
    }
}
